import React from 'react';
import { ChevronLeft } from 'lucide-react';

export default function ScreenHeader({ title, onBack, rightAction, children, titleClassName }) {
  return (
    <div className="bg-white border-b-2 border-gray-200 p-4">
      <div className={`flex items-center gap-3${children ? ' mb-3' : ''}`}>
        {onBack && (
          <button onClick={onBack} className="p-2 hover:bg-gray-100 rounded-full">
            <ChevronLeft size={20} />
          </button>
        )}
        <h1 className={`${titleClassName || 'text-xl font-bold'} flex-1`}>{title}</h1>
        {rightAction}
      </div>
      {children}
    </div>
  );
}
